/**
 * Whether an instructor account is active inside its organization.
 * Serialized as PascalCase strings on the wire.
 */
export enum InstructorStatus {
  Active = "Active",
  Inactive = "Inactive",
}
